export default __webpack_public_path__ + "e5078f25e42cbabe92a33c1ebc593efc.png";